<template>
    <div class="pricehr">
        <!--版本-->
        <div class="ver_box outer">
            <div class="pricemessage">
                <div class="priec__box">
                    <h2>免费版</h2>
                    <span class="price_detail">适用于没有专职的招聘HR的小型初创企业，终身免费</span>
                    <div class="pricess" style="margin-top: 35px;">
                        <span class="pr1s">￥</span>
                        <span class="pr2s" style="color: #0084FF;">0</span>
                        <span class="pr4">元/年</span>
                    </div>
                    <p class="price_tip">限1个用户</p>
                    <!-- <span class="pre_btn"  @click="trial('1')">免费开通</span> -->
                </div>
                <div class="priec__box ml">
                    <img class="tj_icon" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/tj_pic_02%402x.png"/>
                    <h2>标准版</h2>
                    <span class="price_detail">适用于追求效率和灵活性的中小型企业</span>
                    <div class="pricess" style="margin-top: 35px;">
                        <span
                        class="pr1"
                        style="left:50px"
                        >￥</span
                        >
                        <span
                        class="pr2"
                        style="left: 68px;color: #0084FF;"
                        >2999</span
                        >
                        <span class="pr3">元/年/人</span>
                    </div>
                    <!-- <span class="pre_btn2"  @click="trial('1')">申请试用</span> -->
                </div>
                <div class="priec__box ml" style="position: relative;">
                   
                    <h2>专业版</h2>
                    <span class="price_detail">适用于有移动办公、私域流量，渠道交付需求的中大型企业</span>
                    <div class="pricess" style="margin-top: 35px;">
                        <!-- <span
                        class="pr1"
                        style="left: 50px;"
                        >￥</span
                        >
                        <span
                        class="pr2"
                        style="left:68px"
                        >5999</span
                        >
                        <span class="pr3">元/年/人</span> -->
                        <p class="telwork">联系客户经理</p>
                    </div>
                    <!-- <span class="pre_btn2"  @click="trial('3')">申请试用</span> -->
                </div>
                <div class="priec__box ml">
                    <h2>旗舰版</h2>
                    <span class="price_detail">适用于有大量招聘需求且有专门的招聘团队的中大型企业</span>
                    <div class="pricess" style="margin-top: 35px;">
                        <!-- <span
                        class="pr1"
                        style="left: 50px;"
                        >￥</span
                        >
                        <span
                        class="pr2"
                        style="left:68px"
                        >9999</span
                        >
                        <span class="pr3">元/年/人</span> -->
                        <p class="telwork">联系客户经理</p>
                    </div>
                    <!-- <span class="pre_btn2"  @click="trial('2')">申请试用</span> -->
                </div>
            </div>
        </div>
        <!--套餐权益对比-->
        <div class="package_box outer">
            <div class="pack_container inside1490">
                <h2>套餐权益对比</h2>
                <div class="bgimg__table">
                    <div class="bg__title">
                    <span class="sp1">功能</span>
                    <span class="sp1">免费版</span>
                    <span class="sp1">标准版</span>
                    <span class="sp1">专业版</span>
                    <span class="sp1">旗舰版</span>
                    </div>
                    <div class="keyong_table">
                    <ul>
                        <li
                        style="position:relative;display: flex;justify-content: space-between;"
                        v-for="(item, index) in keyonglist"
                        :key="index"
                        :class="{ keyong_table_w: (index % 2) - 1 !== 0 }"
                        >
                       <span class="k1"> {{ item.name }}
                           <span class="dw_tool"> 
                            <p v-show="tindex==index" class="dw_box">{{item.tips}}</p>
                            <img class="icon_tips" @mouseenter="tipshow(index)" @mouseleave="tipshowno()" v-show="item.name=='招聘渠道整合'||item.name=='简历快照数量'||item.name=='招聘助手易猎简历'" src="../../../assets/icon/icon_tips_orange@2x.png" alt=""/>
                           </span>
                       
                            <!-- <el-tooltip ref="tooltip_xy"  class="item" effect="light" placement="top" popper-class="tableTypePopperClass">
                            <div slot="content">{{item.tips}}</div>
                             <img class="icon_tips"  v-show="item.name=='招聘渠道整合'||item.name=='简历快照数量'" src="../../../assets/icon/icon_tips_orange@2x.png" alt=""/>
                            </el-tooltip>
                            <el-tooltip ref="tooltip_xy" class="item" effect="light" placement="top" popper-class="tableTypePopperClass">
                            <div slot="content">把招聘平台的候选人与系统人才库进行精准匹配，将完全匹配的同一候选人显示易猎简历标识</div>
                            <img class="icon_tips2" v-show="item.name=='招聘助手易猎简历'" src="../../../assets/icon/icon_tips_orange@2x.png" alt=""/>
                            </el-tooltip> -->
                        </span>
                        <span class="k2">
                            <span v-show="item.shoutype==1&&item.name!='交付渠道管理'&&item.name!='个性化显示'">{{ item.free }}</span>
                            <img class="icon_type" v-show="item.shoutype==2&&item.free=='支持'" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_newtick%402x.png"/>
                            <img class="icon_type" v-show="item.shoutype==2&&item.free=='不支持'" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_newcross%402x.png"/>
                            <img class="icon_type" v-show="item.shoutype==1&&(item.name=='交付渠道管理'||item.name=='个性化显示')" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_newcross%402x.png"/>
                        </span>
                        <span class="k3">
                            <span v-show="item.shoutype==1&&item.name!='交付渠道管理'">{{item.fast}}</span>
                            <img class="icon_type" v-show="item.shoutype==2&&item.fast=='支持'" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_newtick%402x.png"/>
                            <img class="icon_type" v-show="item.shoutype==2&&item.fast=='不支持'" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_newcross%402x.png"/>
                            <img class="icon_type" v-show="item.shoutype==1&&item.name=='交付渠道管理'" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_newcross%402x.png"/>
                        </span>
                        <span class="k4">
                            <span v-show="item.shoutype==1">{{ item.startup }}</span>
                            <img class="icon_type" v-show="item.shoutype==2&&item.startup=='支持'" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_newtick%402x.png"/>
                            <img class="icon_type" v-show="item.shoutype==2&&item.startup=='不支持'" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_newcross%402x.png"/>
                        </span>
                        <span class="k5">
                            <span v-show="item.shoutype==1">{{ item.standard }}</span>
                            <img class="icon_type" v-show="item.shoutype==2&&item.standard=='支持'" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_newtick%402x.png"/>
                            <img class="icon_type" v-show="item.shoutype==2&&item.standard=='不支持'" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_newcross%402x.png"/>
                        </span>
                        <!-- <div
                            class="leftImg"
                            @mousemove="leftImg = true"
                            @mouseout="leftImg = false"
                        >
                            <img v-if="item.name=='系统外呼'" src="../../../assets/icon/icon_tips_orange@2x.png" alt="" />
                            <div v-if="leftImg&&item.name=='系统外呼'">可通过系统一键外呼候选人，支持APP外呼，运营商线路外呼以及工作手机等外呼方式，可自动记录通话录音。</div>
                        </div> -->
                        </li>
                    </ul>
                    </div>
                    <div class="upper">服务标准</div>
                    <div class="bg__title">
                    <span class="sp1" style="left: 78px">服务等级</span>
                    <span class="sp1" style="left: 275px">基本服务</span>
                    <span class="sp1" style="left: 505px">高级服务</span>
                    <span class="sp1" style="left: 784px">高级服务</span>
                    <span class="sp1" style="left: 1048px">尊享服务</span>
                    </div>
                    <div class="keyong_table">
                    <ul>
                        <li
                        style="position:relative"
                        v-for="(item, index) in servicelist"
                        :key="index"
                        :class="{ keyong_table_w: (index % 2) - 1 !== 0 }"
                        >
                        <span class="k1">{{ item.name }}
                            <!-- <el-tooltip class="item" effect="light" placement="top" popper-class="tableTypePopperClass">
                            <div slot="content">{{item.tips}}</div>
                            <img class="icon_tips" v-show="item.name=='招聘渠道整合'||item.name=='简历快照数量'" src="../../../assets/icon/icon_tips_orange@2x.png" alt=""/>
                            </el-tooltip>
                            <el-tooltip class="item" effect="light" placement="top" popper-class="tableTypePopperClass">
                            <div slot="content">在招聘助手中可对本地人才库中的候选人进行精准匹配，可显示候选人真实的活跃时间。</div>
                            <img class="icon_tips2" v-show="item.name=='招聘助手易猎简历'" src="../../../assets/icon/icon_tips_orange@2x.png" alt=""/>
                            </el-tooltip> -->
                        </span>
                        <span class="k2">
                            <span v-show="item.shoutype==1">{{ item.free }}</span>
                            <img class="icon_type" v-show="item.shoutype==2&&item.free=='支持'" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_newtick%402x.png"/>
                            <img class="icon_type" v-show="item.shoutype==2&&item.free=='不支持'" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_newcross%402x.png"/>
                        </span>
                        <span class="k3">
                            <span v-show="item.shoutype==1">{{item.fast}}</span>
                            <img class="icon_type" v-show="item.shoutype==2&&item.fast=='支持'" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_newtick%402x.png"/>
                            <img class="icon_type" v-show="item.shoutype==2&&item.fast=='不支持'" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_newcross%402x.png"/>
                        </span>
                        <span class="k4">
                            <span v-show="item.shoutype==1">{{ item.startup }}</span>
                            <img class="icon_type" v-show="item.shoutype==2&&item.startup=='支持'" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_newtick%402x.png"/>
                            <img class="icon_type" v-show="item.shoutype==2&&item.startup=='不支持'" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_newcross%402x.png"/>
                        </span>
                        <span class="k5">
                            <span v-show="item.shoutype==1">{{ item.standard }}</span>
                            <img class="icon_type" v-show="item.shoutype==2&&item.standard=='支持'" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_newtick%402x.png"/>
                            <img class="icon_type" v-show="item.shoutype==2&&item.standard=='不支持'" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/icon_newcross%402x.png"/>
                        </span>
                        <!-- <div
                            class="leftImg"
                            @mousemove="leftImg = true"
                            @mouseout="leftImg = false"
                        >
                            <img v-if="item.name=='系统外呼'" src="../../../assets/icon/icon_tips_orange@2x.png" alt="" />
                            <div v-if="leftImg&&item.name=='系统外呼'">可通过系统一键外呼候选人，支持APP外呼，运营商线路外呼以及工作手机等外呼方式，可自动记录通话录音。</div>
                        </div> -->
                        </li>
                    </ul>
                    </div>
                    <div class="button__table">
                        <!-- <p class="btn1" style="margin-left:365px" @click="trial('1')">免费开通</p>
                        <p class="btn2" style="background: linear-gradient( 90deg, #F4DBB1 0%, #EABC6D 100%);margin-left:144px" @click="trial('1')">申请试用</p>
                        <p class="btn2" style="background: linear-gradient( 90deg, #F4DBB1 0%, #EABC6D 100%);margin-left:144px" @click="trial('3')">申请试用</p>
                        <p class="btn2" @click="trial('2')" style="background: linear-gradient( 90deg, #F4DBB1 0%, #EABC6D 100%);margin-left:144px">申请试用</p> -->
                    </div>
                </div>
            </div>
        </div>
        <!--申请试用组件-->
    <populone v-if="windowflags" :isshow="windowflags" :selectId="selectId" :he="true" @handleChange="changewindows" />
    </div>
</template>
<script>
import populone from "@/components/views/popul/populone";
export default {
    name: "pricehr",
    data(){
        return{
            selectId:'',
            windowflags: false,
            tindex:-1,
            keyonglist: [
                    {
                    name: "账号数",
                    free: "1个",
                    fast:'按需',
                    startup: "按需",
                    standard: "按需",
                    tips:'',
                    shoutype:'1'
                    },
                    {
                    name: "简历容量",
                    free: "限5000份简历",
                    fast:'不限',
                    startup: "不限",
                    standard: "不限",
                    tips:'',
                    shoutype:'1'
                    },
                    {
                    name: "面试官账号数",
                    free: "3个",
                    fast:'10个',
                    startup: "30个",
                    standard: "不限",
                    tips:'',
                    shoutype:'1'
                    },
                    {
                    name: "招聘渠道整合",
                    free: "支持",
                    fast:'支持',
                    startup: "支持",
                    standard: "支持",
                    tips:'支持BOSS直聘，智联招聘，前程无忧，58招聘，猎聘，快手等主流招聘平台，招聘顾问可以直接在招聘平台上一键入库，外呼和评价',
                    shoutype:'2'
                    },
                    {
                    name: "招聘助手自动入库",
                    free: "不支持",
                    fast:'支持',
                    startup: "支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "招聘助手易猎简历",
                    free: "不支持",
                    fast:'支持',
                    startup: "支持",
                    standard: "支持",
                    tips:'把招聘平台的候选人与系统人才库进行精准匹配，将完全匹配的同一候选人显示易猎简历标识',
                    shoutype:'2'
                    },
                    {
                    name: "人才库自动激活",
                    free: "不支持",
                    fast:'不支持',
                    startup: "不支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "交付渠道管理",
                    free: "-",
                    fast:'-',
                    startup: "10个",
                    standard: "不限",
                    tips:'',
                    shoutype:'1'
                    },
                    {
                    name: "简历快照数量",
                    free: "2",
                    fast:'3',
                    startup: "3",
                    standard: "5",
                    tips:'允许查看候选人简历多次投递简历附件的最大数量',
                    shoutype:'1'
                    },
                    {
                    name: "人才库",
                    free: "支持",
                    fast:'支持',
                    startup: "支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "招聘进程管理",
                    free: "支持",
                    fast:'支持',
                    startup: "支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "职位管理",
                    free: "支持",
                    fast:'支持',
                    startup: "支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "统计报表",
                    free: "基础报表",
                    fast:'全功能报表',
                    startup: "全功能报表",
                    standard: "全功能报表",
                    tips:'',
                    shoutype:'1'
                    },
                    {
                    name: "个性化显示",
                    free: "标准域名",
                    fast:'自定义域名logo自定义',
                    startup: "自定义域名logo自定义",
                    standard: "自定义域名logo自定义",
                    tips:'',
                    shoutype:'1'
                    },
                    {
                    name: "简历批量导出",
                    free: "支持",
                    fast:'支持',
                    startup: "支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "交付渠道效果分析",
                    free: "不支持",
                    fast:'支持',
                    startup: "支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "微信绑定",
                    free: "不支持",
                    fast:'支持',
                    startup: "支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "移动端交付",
                    free: "不支持",
                    fast:'不支持',
                    startup: "支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "移动端管理看板",
                    free: "不支持",
                    fast:'不支持',
                    startup: "支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "微信分享小程序",
                    free: "不支持",
                    fast:'不支持',
                    startup: "支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "人事管理",
                    free: "不支持",
                    fast:'不支持',
                    startup: "不支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "电子合同",
                    free: "不支持",
                    fast:'不支持',
                    startup: "不支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "企业微信招聘侧边栏",
                    free: "不支持",
                    fast:'不支持',
                    startup: "不支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                ],
                servicelist: [
                    {
                    name: "产品文档",
                    free: "支持",
                    fast:'支持',
                    startup: "支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "产品培训视频",
                    free: "支持",
                    fast:'支持',
                    startup: "支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "在线客服",
                    free: "支持",
                    fast:'支持',
                    startup: "支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "使用答疑",
                    free: "不支持",
                    fast:'支持',
                    startup: "支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "开通培训",
                    free: "不支持",
                    fast:'支持',
                    startup: "支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "专属客户成功",
                    free: "不支持",
                    fast:'支持',
                    startup: "支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                    {
                    name: "同城上门培训",
                    free: "不支持",
                    fast:'不支持',
                    startup: "不支持",
                    standard: "支持",
                    tips:'',
                    shoutype:'2'
                    },
                ],
        }
    },
    metaInfo: {
      title: '易猎云价格-更适合RPO的免费招聘管理系统',
      meta: [
        {
          name: 'keywords',
          content: '易猎云，招聘管理系统，免费，free，批量招聘，数字化'
        },
        {
          name: 'description',
          content: '易猎云招聘管理系统，RPO公司批量招聘数字化首选的招聘系统'
        }
      ]
    },
    mounted(){
        // if (Object.keys(this.$route.query).length) {
        //     this.routeData = this.$route.query;
        //     }
        //     const { u = "" } = this.routeData;
        //     if (!u) {
        //     console.log("官网价格");
        //     zhuge.track("官网价格页", {
        //         渠道: "pc",
        //         utm类型: "自然流量",
        //     });
        //     } else {
        //     zhuge.track("官网价格页", {
        //         渠道: "pc",
        //         utm类型: "驱动流量",
        //     });
        //     }
    },
    
    components: {
        populone,
    },
    methods:{
        trial(id) {
        this.selectId='';
        console.log(this.selectId,'@@@');
        this.windowflags = true;
        },
        changewindows(value) {
         this.windowflags = value;
        },
        tipshow(index){
           this.tindex=index;
        },
        tipshowno(){
            this.tindex=-1;
        }
    }
}
</script>
<style lang="less" scoped>
@import "~@/assets/css/style/index.less";
.pricehr{
    .ver_box{
            width: 100%;
            height: 509px;
            background: #f5faff;
            padding-top: 52px;
            box-sizing: border-box;
            .pricemessage{
                display: flex;
                position: absolute;
                justify-content: space-between;
                width: 1490px;
                height: 380px;
                left: 50%;
                transform: translateX(-50%);
                z-index: 10;
                .priec__box{
                    position: relative;
                    width: 338px;
                    background: #ffffff;
                    border-radius: 11px;
                    box-shadow: 0px 7px 9px 0px #E9EDFE;
                    cursor: pointer;
                    .tj_icon{
                        position: absolute;
                        width: 97px;
                        height: 100px;
                        top: -3px;
                        right: 0px;
                    }
                    h2{
                        text-align: center;
                        font-size: 28px;
                        color: #1D2754;
                        margin-top: 40px;
                    }
                    .price_detail{
                        display: inline-block;
                        font-size: 18px;
                        color: #7C848F;
                        margin: 0 37px;
                        line-height: 25px;
                        margin-top: 25px;
                    }
                    .pricess {
                        width: 100%;
                        height: 62px;
                        margin-top: 20px;
                        position: relative;
                        .pr1 {
                            position: absolute;
                            font-size: 20px;
                            color: #000000;
                            left: 0px;
                            top: 5px;
                        }

                        .pr1s {
                            position: absolute;
                            font-size: 20px;
                            color: #000000;
                            left: 100px;
                            top: 5px;
                        }

                        .pr2 {
                            position: absolute;
                            font-size: 44px;
                            color: #1d2754;
                            line-height: 62px;
                            left: 36px;
                            font-weight: 510;
                        }

                        .pr2s {
                            position: absolute;
                            font-size: 44px;
                            color: #1d2754;
                            line-height: 62px;
                            left: 120px;
                            font-weight: 510;
                        }

                        .pr3 {
                            position: absolute;
                            font-size: 24px;
                            color: #686d85;
                            line-height: 70px;
                            left: 170px;
                        }

                        .pr4 {
                            position: absolute;
                            font-size: 24px;
                            color: #686d85;
                            line-height: 70px;
                            left: 144px;
                        }
                    }
                    .price_tip{
                        width: 100%;
                        text-align: center;
                        font-size: 16px;
                        color: #0084FF;
                        margin-top: 27px;
                    }
                    .pre_btn{
                        display: inline-block;
                        width: 155px;
                        height: 44px;
                        text-align: center;
                        line-height: 44px;
                        margin: 0 auto;
                        margin-left: 92px;
                        margin-top: 27px;
                        border-radius: 5px;
                        border: 1px solid #0084FF;
                        font-size: 18px;
                        color: #0084FF;
                    }
                    .pre_btn2{
                        display: inline-block;
                        width: 155px;
                        height: 44px;
                        text-align: center;
                        line-height: 44px;
                        margin: 0 auto;
                        margin-left: 92px;
                        margin-top: 75px;
                        border-radius: 5px;
                        background: #0084FF;
                        font-size: 18px;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .package_box{
            width: 100%;
            background: #fbfdff;
            padding-top: 40px;
            .pack_container{
                h2{
                    text-align: left;
                    font-size: 28px;
                    color: #1D2754;
                }
                .bgimg__table {
                    margin-top: 30px;
                    z-index: 5;
                    .bg__title {
                        position: relative;
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                        height: 86px;
                        line-height: 86px;
                        .sp1 {
                            display: inline-block;
                            flex: 1;
                            font-weight: 500;
                            font-size: 24px;
                            color: #1D2754;
                            text-align: center;
                        }
                    }

                    .upper {
                        width: 100%;
                        height: 105px;
                        background: #ffffff;
                        font-size: 28px;
                        color: #1d2754;
                        line-height: 125px;
                        text-align: left;
                    }

                    .upper__talbe {
                        width: 100%;
                        height: 104px;
                        border-bottom: 1px solid #1ea6fc;

                        li {
                        width: 100%;
                        height: 52px;

                        .t1 {
                            display: inline-block;
                            width: 126px;
                            height: 52px;
                            font-size: 18px;
                            color: #1d2754;
                            line-height: 52px;
                            text-align: center;
                            margin-left: 143px;
                        }

                        .t2 {
                            display: inline-block;
                            width: 30px;
                            height: 52px;
                            font-size: 18px;
                            color: #1d2754;
                            line-height: 52px;
                            text-align: center;
                            margin-left: 170px;
                        }

                        .t3 {
                            display: inline-block;
                            width: 40px;
                            height: 52px;
                            font-size: 18px;
                            color: #1d2754;
                            line-height: 52px;
                            text-align: center;
                            margin-left: 170px;
                        }

                        .t4 {
                            display: inline-block;
                            width: 40px;
                            height: 52px;
                            font-size: 18px;
                            color: #1d2754;
                            line-height: 52px;
                            text-align: center;
                            margin-left: 170px;
                        }

                        .t5 {
                            display: inline-block;
                            width: 51px;
                            height: 52px;
                            font-size: 18px;
                            color: #1d2754;
                            line-height: 52px;
                            text-align: center;
                            margin-left: 150px;
                        }
                        }
                    }

                    .keyong_table {
                        width: 100%;
                       
                        li {
                        width: 100%;
                        font-size: 18px;
                        color: #1d2754;
                        line-height: 52px;
                        text-align: center;
                        display: flex;
                        .k1 {
                            display: inline-block;
                            flex: 1;
                            height: 52px;
                            font-size: 20px;
                            color: #1D2754;
                            line-height: 52px;
                            text-align: left;
                            text-indent: 40px;
                        }

                        .k2 {
                            flex: 1;
                            height: 22px;
                            display: inline-block;
                            text-align: center;
                            font-size: 20px;
                            color: #1D2754;
                            line-height: 52px;
                            text-align: center;
                           
                        }

                        .k3 {
                           flex: 1;
                            height: 22px;
                            display: inline-block;
                            text-align: center;
                            font-size: 20px;
                            color: #1D2754;
                            line-height: 52px;
                            text-align: center;
                            
                        }

                        .k4 {
                            flex: 1;
                            height: 22px;
                            display: inline-block;
                            text-align: center;
                            font-size: 20px;
                            color: #1D2754;
                            line-height: 52px;
                            text-align: center;
                           
                        }

                        .k5 {
                          flex: 1;
                            height: 22px;
                            display: inline-block;
                            text-align: center;
                            font-size: 20px;
                            color: #1d2754;
                            line-height: 52px;
                            text-align: center;
                           
                        }
                        }
                    }

                    .button__table {
                        width: 100%;
                        height: 52px;
                        display: flex;
                        padding-top: 41px;
                        box-sizing: border-box;
                        p {
                        
                        width: 158px;
                        height: 44px;
                        text-align: center;
                        line-height: 44px;
                        cursor: pointer;
                        }
                        .btn1{
                            border-radius: 5px;
                            border: 1px solid #0084FF;
                            font-size: 18px;
                            color: #0084FF;
                        }
                        .btn2{
                            background: linear-gradient( 90deg, #F4DBB1 0%, #EABC6D 100%);
                            border-radius: 5px;
                            font-size: 18px;
                            color: #361900;
                        }
                    }
                    }
            }
        }
}
.ml{
    margin-left: 16px;
}
.icon_tips{
        display:inline-block;
        width:16px;
        height:17px;
        margin-top:-2px;
        margin-left: 5px;
        vertical-align: middle;
        cursor: pointer;
      }
      .icon_tips2{
        position: absolute;
        display: inline-block;
        width:16px;
        height:17px;
        top: 18px;
        left: 205px;
        vertical-align: middle;
        cursor: pointer;
      }
      .tips_text{
        position: absolute;
        left: 0px;
        top: -37px;
        font-size: 16px;
        color: #ff572e;
      }
.keyong_table_w {
  background: #FAFAFC;
}
.icon_type{
    width: 24px;
    height: 24px;
    margin: 0 auto;
    margin-top: 13px;
}
.telwork{
    font-size: 28px;
    color: #0084FF;
    text-align: center;
    padding-top: 25px;
}
.dw_tool{
    position: relative;
}
.dw_box{  
    width: max-content;
    max-width: 450px;
    position: absolute;
    padding: 10px 8px;
    left: 50%;
    transform: translateX(-50%);
    bottom: 30px;
    box-sizing: border-box !important;
    background-color:#fff9f5;
    border: solid 1px #FF572E;
    border-radius: 5px;
    text-indent: 0px;
    line-height: 20px;
    text-align: left;
    font-size: 14px;
    z-index: 9999;
    color: #FF572E!important;
    &::after{
        position: absolute;
        bottom: -17px;
        left: 50%;
        transform: translateX(-50%);
        content: '';
        width: 0;
        height: 0;
        border: 9px solid transparent;
        border-top-color: #FF572E; 
        z-index: 1;
    }
    &::before{
        position: absolute;
        bottom: -16px;
        left: 50%;
        transform: translateX(-50%);
        content: '';
        width: 0;
        height: 0;
        border: 9px solid transparent;
        border-top-color: #fff9f5; 
        z-index: 2;
    }
}

</style>
<style>
.el-tooltip__popper.is-light {
  background-color: #FFF6F4!important;
  border: 0.5px solid #FF572E!important;
  font-size: 14px !important;
}
.tableTypePopperClass {
  color: #FF572E!important;
  background-color: #fff9f5!important;
  border: 0.5px solid #fa9658!important;
  font-weight: normal!important;
  font-size: 12px;
  letter-spacing: 0px;
  font-stretch: normal;
  font-family: PingFangSC-Regular;
  padding: 10px 8px 10px;
  /* line-height: 20px; */
    max-width: 500px;
    /* color: #333!important; */
    line-height: 18px!important;
    /* border: 1px solid #EBEEF5!important; */
  }

  .tableTypePopperClass[x-placement^=bottom] .popper__arrow{
    border-bottom-color: #fa9658!important;
  }
  .tableTypePopperClass[x-placement^=bottom] .popper__arrow:after {
    border-bottom-color: #fff9f5!important;
  }

  .tableTypePopperClass[x-placement^=top] .popper__arrow{
    border-top-color: #fa9658!important;
  }
  .tableTypePopperClass[x-placement^=top] .popper__arrow:after {
    border-top-color: #fff9f5!important;
  }

  .el-select-dropdown__wrap{
    max-height: 259px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/price/pricehr.vue